<template>

  <div class="dashboard">
    
    <header class="topbar">
      <nav class="navbar navbar-expand-lg navbar-light bg-light">
        <router-link class="navbar-brand" to="/">W3 Website Builder</router-link>
        <ul class="ml-auto navbar-nav" >
          <router-link class="nav-link" href="#" to="/logout">Logout</router-link>
        </ul>
      </nav>
    </header>

    <div class="container">
      <div class="d-flex align-items-center justify-content-between my-3">
        <h1>Projects</h1>
        <router-link class="btn btn-primary" :to="{name:'project-new'}">New</router-link>
      </div>
      <div class="projects d-flex flex-wrap">
        <div class="item" v-for="project in projects" :key="project.id">
          <div class="card">
            <img class="card-img-top" :src="'http://web2jpg.api.scaalar.com/desktop/300x300/http://'+url(project.slug)+'?'+project.updated_at" alt="">
            <h5 class="card-header">{{ project.name }}</h5>
            <div class="card-body">
              <p><small><a :href="'http://'+url(project.slug)" target="_blank">Preview</a></small></p>
              <p><small class="text-muted">Date: {{ dataBr(project.created_at) }}</small></p>
              <button class="btn btn-block btn-light" @click="editProject(project.id)">Manage</button>
            </div>
            <!-- <div class="card-footer"></div> -->
          </div>
        </div>
      </div>

      <div class="alert alert-info mt-5 text-center">
        <p>W3 Website Builder is under development.</p>
        <p>Contact: <a href="mailto:guilherme@scaalar.com">E-mail</a>.</p>
      </div>


    </div>



  </div>

</template>


<style scoped>
.projects { display: inline;}

.item { padding:10px ; flex:0 1 25%; }

</style>


<script>
import axios from 'axios';
import Vue from 'vue'
import gHeader from '../components/gHeader.vue'

export default {
  name: 'dashboard',
  components:{'g-header':gHeader},
  data() {
    return {
      projects:[],
    }
  },
  methods:{
    url(slug){
      return slug+'.w3.scaalar.com';
    },
    dataBr(data){
      var d = new Date(data);
      return ('0'+d.getDate()).substr(-2) + '/' +('0'+(d.getMonth()+1)).substr(-2)+'/'+d.getFullYear();
    },
    getProjects(){
      axios({
        url: '/api/projects',
      }).then((res) => {
        this.projects = res.data;
      });
    },
    editProject(id){
      this.$router.push({path:'/project/'+id})
    },

  },
  mounted(){
    this.getProjects();

  }

}



</script>
